import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function PrivacyPolicy() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hasAccepted = localStorage.getItem('mimate_privacy_accepted');
    if (!hasAccepted) {
      // Small delay before showing
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('mimate_privacy_accepted', 'true');
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-79">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-[60] bg-mimate-text text-mimate-bg p-4 shadow-2xl border-t border-mimate-primary/20" data-id="element-80">
          <div className="container mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-81">
            <div className="text-sm text-mimate-bg/80 flex-grow" data-id="element-82">
              <p data-id="element-83">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web. Al continuar navegando,
                aceptas nuestra política de privacidad y el uso de datos para
                contactarte sobre tus citas.
              </p>
            </div>
            <div className="flex items-center gap-4 flex-shrink-0" data-id="element-84">
              <button onClick={handleAccept} className="bg-mimate-primary text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-mimate-primary/90 transition-colors whitespace-nowrap" data-id="element-85">
                Aceptar
              </button>
              <button onClick={() => setIsVisible(false)} className="text-mimate-bg/60 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-86">
                <X size={20} data-id="element-87" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}